import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { verifyTransactionStart } from "../../redux/transactions/reducer";
import { selectIsVerifyingTransaction } from "../../redux/transactions/selectors";
import { errorNotifier, successNotifier } from "../../utils/helpers";

const useTransactionVerify = () => {
  const dispatch = useDispatch();
  const [loadingId, setLoadingId] = useState("");
  const isVerifying = useSelector(selectIsVerifyingTransaction);

  const verifyTransaction = (data, onSuccess, onFailure) => {
    setLoadingId(data?.referenceId);
    dispatch(
      verifyTransactionStart({
        data,
        onSuccess: (raw) => {
          successNotifier(
            `Transaction for ${raw?.username} verified successfully`
          );
          if (onSuccess) {
            onSuccess();
          }
        },
        onFailure: () => {
          errorNotifier(
            `Unable to verify transaction for referenceID of  ${data?.referenceId}`
          );
          if (onFailure) {
            onFailure();
          }
        },
      })
    );
  };

  return {
    verifyingTransaction: isVerifying,
    verifyTransaction,
    loadingId,
  };
};

export default useTransactionVerify;
